module.exports = __webpack_public_path__ + "static/media/02.120e0953.JPG";